"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyLeaf = void 0;
exports.emptyLeaf = { type: 'empty' };
//# sourceMappingURL=types.js.map